import type {ErrorProcessor} from '../types'
import {sendOnly} from '../utils'

const MIUI = 'XiaoMi/MiuiBrowser'

export const processKnownIssues: ErrorProcessor = error => {
  if (
    error.message === 'Script error.' &&
    Ya.Rum.getErrorSetting('platform') === 'touch' &&
    Ya.Rum.getErrorSetting('page')!.startsWith('route.') &&
    [`${MIUI}/14.`, `${MIUI}/13.`, 'iPhone OS 12_'].some(ua => navigator.userAgent.includes(ua))
  ) {
    return sendOnly(0.1) && error
  }

  return error
}
